import MapView from '@arcgis/core/views/MapView';
import FeatureSnappingLayerSource from '@arcgis/core/views/interactive/snapping/FeatureSnappingLayerSource';
import LayerView from '@arcgis/core/views/layers/LayerView';
import SnappingOptions from '@arcgis/core/views/interactive/snapping/SnappingOptions';
import LocalStoragePreferences from '../utils/local-storage-preferences';
import { SKETCH_LAYER_TITLE, VIEW_LAYER_TITLE } from './providers';

const storage = () => (new LocalStoragePreferences());

export const initialSnappingSettings = () => {
  const existingSettings = storage().lastUsedSnappingSettings;
  if (!existingSettings) {
    return {
      enabled: true, featureEnabled: true, selfEnabled: true,
    };
  }

  const { enabled, featureEnabled, selfEnabled } = existingSettings;
  return { enabled, featureEnabled, selfEnabled };
};

export const extractLayersForSnapping = (mapView: MapView) => {
  const layers: FeatureSnappingLayerSource[] = [];

  const existingSettings = storage().lastUsedSnappingSettings;
  const targetLayerTitles = existingSettings?.featureSourceTitles || [];

  mapView.layerViews.forEach((layerView: LayerView) => {
    const { layer } = layerView;
    const { title, visible } = layer;

    const useLayerForNewUser = !existingSettings
      && title
      && ![SKETCH_LAYER_TITLE, VIEW_LAYER_TITLE].includes(title)
      && visible;
    const restoreSavedLayer = targetLayerTitles?.length
      && targetLayerTitles.includes(title)
      && visible;

    if (useLayerForNewUser || restoreSavedLayer) {
      // @ts-ignore
      layers.push(new FeatureSnappingLayerSource({ layer, enabled: true }));
    }
  });

  return layers;
};

export const persistSnappingSettings = (snappingOptions: SnappingOptions) => {
  const layersToIgnore = ['SVM Internal'];
  const featureSourceTitles: string[] = [];
  const { featureEnabled, selfEnabled, enabled: fullEnable } = snappingOptions;

  snappingOptions.featureSources.forEach((featureSource) => {
    const { layer: { title }, enabled: ftrSrcEnabled } = featureSource;
    if (ftrSrcEnabled && layersToIgnore.indexOf(title) < 0) {
      featureSourceTitles.push(title);
    }
  });

  storage().setLastUsedSnappingSettings({
    enabled: fullEnable,
    featureEnabled,
    selfEnabled,
    featureSourceTitles,
  });
};
